import FriendsReferralInviteeContainer from './friends-referral-invitee.container';

export default FriendsReferralInviteeContainer;
